import { UserManagerService } from './../userManager/user-manager.service';
import { HttpService } from './../../../wrappers/Http';
import { Injectable, HostListener } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { StorageService } from '../../storage.service';
import * as $ from 'jquery';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../modal-service/ModalService';
import { ConfigService } from '../../config/config.service';
import { TurfBetObject } from 'src/app/interfaces/bet-object.model';
import { EndPoints, TurfEndpoints } from 'src/app/configs';
import { SkeletonServiceService } from 'src/app/components/skeleton-service.service';
import { buildSilkUrl, DEFAULT_RACECOURSE_CODE } from 'src/app/utilities/casaque.function';
// import { ACTIVE_GAMES_RESP } from 'src/app/sample-data/active-game-response.data';
// import { FINISHED_RACE_RAPPORTS_20250926 } from 'src/app/sample-data/race-rapport.data';

@Injectable({
  providedIn: 'root',
})
export class TurfServiceService {
  public requireConfirmation: boolean;
  private _meetingId;
  private _raceId;
  private _raceReport: any;
  // public reportParticipants: any;
  public betObject: any;
  public selectedMeeting: any;
  public reportResults: any = [];
  public racesInMeeting: any;
  public eventDate = new Date();
  public betsArray: Array<TurfBetObject> = [];
  public selectedHorses: Set<string> = new Set();
  activeRaceInSelectedMeeting: any;
  partantsInactiveRace: any = [];
  activeGameObject: any;
  checkBoxConfig: any;
  onBetOptionSelected$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  courseChange$: Subject<any> = new Subject();
  activeReport: any;
  activeReportNonPartant: any;
  reportPartants: any = [];
  reportRap: any = [];
  nonPartant: any;
  report: any;
  spotGametype: boolean;
  betLoader = false;

  activeRaceDetail: any;
  activeCombinationBtn: any;
  activeBets: Array<TurfBetObject> = [];
  reportLoader: boolean;
  reportError: boolean = false;
  onViewReportClickEvent$: Subject<{}> = new Subject();
  onActiveRaceClickEvent$: Subject<{}> = new Subject();
  amountTotal: number;
  betAmount: number = 0;
  combinations: any;
  combinationsValue: number;
  activeCombinations: number;
  disbld: boolean;
  alert: boolean;
  spotIcon: any;
  scoltop: string;
  national: any;
  private savebetParam: {
    sid?: any;
    number: any;
    ref: string;
    internal_ref?: string;
    channel: number;
    format: string;
    pwd: string;
    userid: any;
    str_From: any;
    mtv?: number;
    uid?: string;
  };
  toutOdre: any = false;
  cagnoteGames: Array<any> = [];
  message: any;
  partants: any;
  rawActiveGames: Promise<any>;
  load: boolean;
  games: any;
  maxSelections = false;
  private reunionCodes: { text: string; code: string }[] = [];
  constructor(
    private httpHandler: HttpService,
    public userService: UserManagerService,
    public storageService: StorageService,
    private translate: TranslateService,
    private modalService: ModalService,
    private configService: ConfigService,
    private skeletonService: SkeletonServiceService

  ) {
    //  console.log( 'event Date' , this.eventDate);
    //  let me = this
    // this.websocket.getCagnote.subscribe((data)=>{
    //   if(data.length > 0){
    //     me.cagnoteGames = data;
    //     console.log('cagnots', me.cagnoteGames)
    //   }
    //   me.cagnoteGames= []
    // })
    this.loadReunionCodes();
  }

    private loadReunionCodes(): void {
      fetch('assets/statics/reunion_code.json')
        .then((res) => res.json())
        .then((res) => {
          this.reunionCodes = res || [];
        })
        .catch(() => {
          this.reunionCodes = [];
        });
    }
  racereport() {
    const me = this;
    me.onViewReportClickEvent$.subscribe((report) => {
      if (report.hasOwnProperty('id')) {
        me.report = report;
        // console.log(report, 'race-report')
        this.nonPartant = this.report.nonPartant;
        // return this.nonPartant;
      } else {
        me.report = [];
      }
    });
  }

  helloTurf() {
    // console.log("hello from truf service");
  }

  public get getMeetingId() {
    return this._meetingId;
  }

  public set setMeetingId(value) {
    this._meetingId = value;
  }

  public get getRaceId() {
    return this._raceId;
  }

  public set setRaceId(value) {
    this._raceId = value;
  }

  public get getraceReport() {
    return this._raceReport;
  }

  public set setraceReport(value) {
    this._raceReport = value;
  }

  onMeetingSelect(meeting: any) {
    if (this.selectedMeeting == meeting) {
      return;
      // this.storageService.deleteItem("selectedMeeting");
    } else {
      this.selectedMeeting = meeting;
      this.racesInMeeting = meeting.races;

      this.storageService.save('selectedMeeting', meeting);
    }
  }

  formatHeader(eventDate?) {
    // console.log("event date" , this.eventDate)
    moment.locale(this.translate.currentLang);

    const today = eventDate
      ? moment(eventDate).format('LLLL')
      : moment().format('LLLL');

    const todayArr = today.split(' ');

    return (
      todayArr[0] + ' ' + todayArr[1] + ' ' + todayArr[2] + ' ' + todayArr[3]
    );
  }

  formatDate(date) {
    const monthNames = [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
    ];
    let day = date ? new Date().getDate() : date.getDate().toString();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    day = day + '';
    day = day.trim().length == 1 ? '0' + day : day;

    return day + '/' + monthNames[monthIndex] + '/' + year;
  }



  casaqueUrl(meetingName:string, race: any, meetingCode: string, partantNo: string) {
    if (!race && this.activeRaceInSelectedMeeting) {
      race = this.activeRaceInSelectedMeeting;
    }

    if((!meetingName || !meetingCode)){
      const meetingObj = this.selectedMeeting
        ? this.selectedMeeting
        : this.storageService.getObject('selectedMeeting', {});
      meetingName = meetingObj.libelle;
      meetingCode = meetingObj.strCode;
    }

    if (!race && !this.activeRaceInSelectedMeeting) return '';

    // Use the current date if race date is not available
    const eventDate = race.racedt ? new Date(race.racedt) : new Date();

    const racecourseCode = this.getRacecourseCode(meetingName, race.strCode);
    return buildSilkUrl(eventDate, racecourseCode, race.numero, partantNo, this.configService.PROXIES.casaque_baseUrl);
  }

  onRaceSelect(race: any, national?: any) {
    this.national = '';
    this.activeRaceDetail = national ? 'national' : '';
    if (!$('#race-' + race.numero + national).hasClass('open')) {
      // close all open details
      $('[id^=\'race-\']').removeClass('open');
      $('[id^=\'race-details-\']').css('display', 'none');

      // close all report details
      $('[id^=\'race-\']').removeClass('open');
      $('[id^=\'report-\']').css('display', 'none');

      this.initRaceDetailsComponentData(race);

      $('#race-' + race.numero + national).addClass('open');

      // show race details view
      $('#race-details-' + race.numero + national).css('display', '');
      this.scoltop = 'race-' + race.numero;
      this.national = national;
      // this.onWindowScroll("#race-" + race.numero + national)
    } else {
      $('#race-' + race.numero + national).removeClass('open');
      this.scoltop = '';
      // hide race details view
      $('#race-details-' + race.numero + national).css('display', 'none');
    }
  }

  initRaceDetailsComponentData(race) {
    this.activeCombinationBtn = 1;
    this.activeRaceInSelectedMeeting = race;
    this.partantsInactiveRace = race.partants;
    // this.onGameTypeSelect(race.jeu.split("@")[0]);
  }

  showSpotIcon() {
    let moveout = false;
    // console.log(this.activeRaceInSelectedMeeting)
    if (!this.activeRaceInSelectedMeeting.jeu) {
      return
    }
    for (const game of (this.activeRaceInSelectedMeeting.jeu || '').split('@')) {
      if (game.includes('|SI, CE')) {
        this.spotIcon = true;
        // console.log("show Spot")
        moveout = true;
        break;
      }
      if (moveout) {
        break;
      }
    }
  }
  onGameTypeSelect(game) {
    // set active btn to standard
    this.showSpotIcon();
    if (this.spotGametype) {
      this.activeCombinationBtn = 2;
    } else {
      this.activeCombinationBtn = 1;
    }
    this.betAmount = 0;
    const gameInfo = game.split('-');

    this.activeGameObject = {
      icon: gameInfo[0],
      prixdeBase: gameInfo[1],
      coefMax: gameInfo[2],
      numbreCheveauxBase: Number(gameInfo[3]),
      formuleDeJeur: gameInfo[4].split(','),
      color: gameInfo[5],
      touteOdre: gameInfo[6],
      flexi: gameInfo[7],
      spot: gameInfo[8],
      spotChevalLength: Number(gameInfo[8].split('|')[0]),
    };
    // console.log("checking for spot games", this.activeGameObject);

    let checkBoxConfig;

    if (this.activeGameObject.formuleDeJeur.length < 2) {
      checkBoxConfig = {
        name: this.gameTypeToName(this.activeGameObject.icon),
        nbtn: 1,
        stand: true,
        hasChamp: false,
      };
    } else if (this.activeGameObject.formuleDeJeur.length > 2) {
      checkBoxConfig = {
        name: this.gameTypeToName(this.activeGameObject.icon),
        nbtn: 2,
        stand: true,
        champ: true,
        hasChamp: true,
      };
    } else {
      checkBoxConfig = {
        name: this.gameTypeToName(this.activeGameObject.icon),
        nbtn: 2,
        stand: true,
        champ: true,
        hasChamp: true,
      };
    }

    this.activeGameObject.check = checkBoxConfig;
    this.onBetOptionSelected$.next(true);
  }

  gameTypeToName(gameType) {
    let gameName = '';

    switch (gameType) {
      case 'PSG':
        gameName = 'gm_simple_gagnant';
        break;

      case 'PSP':
        gameName = 'gm_simple_place';
        break;

      case 'PCG':
        gameName = 'gm_couple_gagnant';
        break;

      case 'PCP':
        gameName = 'gm_couple_place';
        break;

      case 'P24':
        gameName = 'gm_2_sur_4';
        break;

      case 'PTRIO':
        gameName = 'gm_ptrio';
        break;

      case 'PMM':
        gameName = 'gm_multi';
        break;

      default:
        gameName = 'gm_' + gameType.toLowerCase();
        break;
    }

    return gameName;
  }

  viewReport(race: any, national?: any) {

    // console.log("national", national)
    this.activeRaceDetail = national ? 'national' : '';
    // console.log(race)
    if (!$('#race-' + race.numero + national).hasClass('open')) {
      $('[id^=\'race-\']').removeClass('open');
      $('[id^=\'report-\']').css('display', 'none');

      // close all open details
      $('[id^=\'race-\']').removeClass('open');
      $('[id^=\'race-details-\']').css('display', 'none');

      // show loader
      $('#report-loader-' + race.numero + national).css('display', '');
      $('#race-' + race.numero + national).addClass('open');

      // show race details view
      $('report-' + race.numero + national).css('display', '');

      this.scoltop = 'race-' + race.numero + national;

      this.getReportData(this.selectedMeeting.numero, race.numero, national);
      this.scoltop = 'race-' + race.numero + national;
      this.national = national;

      // this.onWindowScroll("race-" + race.numero)

      // // console.log('open drop-down');
      // $('#race-' + race.numero).addClass('open');

      // // show report section
      // $('#report-' + race.numero).css('display', '');

      // show close btn
      // $('#closeRaceBt-' + race.numero).css('display', 'block');
    } else {
      this.activeReport = {};
      $('#race-' + race.numero + national).removeClass('open');

      // hide report section
      $('#report-' + race.numero + national).css('display', 'none');
      this.scoltop = '';
      // this.turfServices.onViewReportClickEvent$.next({});
      // $('#closeRaceBt-' + race.numero).css('display', 'none');
    }
  }

  remove() {
    this.betsArray = [];
    this.selectedHorses.clear();
    this.betObject = {};
    this.disbld = false;
    this.activeCombinations = 0;
    this.clearCache();
    this.betAmount = 0;
    this.maxSelections = false;
    // this.turfService.activeRaceInSelectedMeeting=[];
    // this.turfService.activeGameObject=[];
    // this.turfService.onRaceSelect(
    //   this.turfService.activeRaceInSelectedMeeting,
    //   ""
    // );
    // this.turfService.onRaceSelect(
    //   this.turfService.activeRaceInSelectedMeeting,
    //   ""
    // );
    // this.turfService.onRaceSelect(race);
  }
  timeConverter(num: number): string {
    const hours = Math.floor(num / 60);
    const minutes = num % 60;

    if (hours > 0 && minutes > 0) {
      return hours + ' hr ' + minutes + ' min';
    } else if (hours > 0 && minutes == 0) {
      return hours + 'hr';
    } else {
      return minutes + ' min';
    }
  }
  initReportComponentData(report) {
    this.activeReport = report;
    // this.reportPartants = this.activeReport['partants'];
    this.reportPartants = this.activeReport.arrivee
      ? this.orderWinningPartants(
        this.activeReport.arrivee,
        this.activeReport.partants
      )
      : this.activeReport.partants || [];

    this.reportRap = this.formateResultObj(this.activeReport.rap);
  }

  formateResultObj(reportObj) {
    const reportArr: any[] = [];
    if (!reportObj) {
      return reportArr;
    }

    Object.keys(reportObj).forEach((key) => {
      const obj = reportObj[key];
      obj.key = key;
      reportArr.push(obj);
    });

    return reportArr;
  }

  orderWinningPartants_(partants, arrivee) {
    const orderdPartants = [];
    const arriveeArr = arrivee.split('-');
    for (let i = 0; i < arrivee.length; i++) {
      const arriKey = arrivee[i];
      for (let j = 0; j < partants.length; j++) {
        const partant = partants[j];
        if (arriKey === partant.numero) {
          orderdPartants.push(partant);
        }
      }
    }

    return orderdPartants;
  }

  orderWinningPartants(arrivee, partants) {
    const result = [];
    const order = arrivee.split`-`.map((x) => +x);
    order.forEach(function (key) {
      let found = false;
      partants = partants.filter(function (item) {
        if (!found && item.numero == key) {
          result.push(item);
          found = true;
          return false;
        } else {
          return true;
        }
      });
    });
    return result;
  }

  ojectToArrOfOject(obj) {
    const arrOfObj = [];

    Object.keys(obj).forEach((key) => { });

    return arrOfObj;
  }

  clearReportComponentValues() {
    this.activeReport = {};
    // this.reportPartants = this.activeReport['partants'];
    this.reportPartants = [];

    this.reportRap = [];
    this.reportError = false;
  }

  getReportData(meetingId: any, raceId: any, national?: any) {
    const me = this;
    const params = { cid: raceId, rid: meetingId };

    this.clearReportComponentValues();
    me.getRaceReport(params).then((resp) => {
      $('#report-loader-' + raceId + national).css('display', 'none');

      if (resp.hasOwnProperty('tcourse') && resp.tcourse.length > 0) {
        me.reportError = false;
        me.initReportComponentData(resp.tcourse[0]);

        // console.log('open drop-down');
        $('#race-' + raceId + national).addClass('open');

        // show report section
        $('#report-' + raceId + national).css('display', '');
      } else {
        me.reportError = true;
      }
    }).catch((err) => {
      // console.log(`error fetching report data for ${meetingId}-${raceId}`, err);

      $('#report-loader-' + raceId + national).css('display', 'none');
      me.clearReportComponentValues();
      me.reportError = true;
    });
  }

  scrollToElement(param, type?) {
    let elementList;
    if (type && type === 'class') {
      elementList = document.querySelectorAll('.' + param);
    } else {
      elementList = document.querySelectorAll('#' + param);
    }
    const element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: 'smooth' });
  }

  // HTTP Requests
  getActiveGames(eventData?): Promise<any> {
    var params: any = {
      channel: 7,
      versioncode: 3,
      date_jr: eventData ? moment(eventData).format('YYYY-MM-DD') : ''
    };

    let endpoint = this.configService.loadingCacheGames ? TurfEndpoints.getCachedActiveGames : TurfEndpoints.getActiveGames
    let gateway = this.configService.loadingCacheGames ? this.configService.PROXIES.cache_turf_gateway : this.configService.PROXIES.turf_gateway;

    this.rawActiveGames = this.httpHandler.get_no_auth(
      gateway +
      endpoint,
      params
    );
    // return new Promise((resolve, reject) => resolve(
    //   {data: ACTIVE_GAMES_RESP}
    // ))
    return this.rawActiveGames;
  }

    getRacecourseCode(meetingName: string, backendCode?: string): string {
      if (backendCode) {
        return backendCode;
      }

      const normalizedName = (meetingName || '').trim().toUpperCase();
      const match = this.reunionCodes.find((entry) => normalizedName.includes(entry.text));

      return match ? match.code : DEFAULT_RACECOURSE_CODE;
    }

  getRaceReport(params): Promise<any> {
    // return new Promise((resolve, reject) => {
    //   resolve(FINISHED_RACE_RAPPORTS_20250926);
    // });
    return this.httpHandler.get_no_auth(
      this.configService.PROXIES.turf_gateway + TurfEndpoints.getRaceReport,
      params
    );
  }
  calculateNewAmount(data: TurfBetObject) {
    if (!Number(data.coef) || !Number(data.coefMax)){
      this.betAmount = 0;
    }else {
      if (!(Number(data.coef) && (Number(data.coef) <= Number(data.coefMax)))) {
        this.alert = true;
      }
      this.alert = false;
      this.betAmount = this.getAmount(data);
      data.value = this.betAmount;
      data.combinations = this.combinationsValue;
    }

  }
  clearCache() {
    this.storageService.delete_cookie("betObject")
    this.storageService.delete_cookie("selectedHorses")
    this.storageService.delete_cookie("betsArray")
    this.storageService.delete_cookie("activeRace");
    this.storageService.delete_cookie("activeGameObject");
    this.storageService.delete_cookie("activeObject");
    this.storageService.delete_cookie("activeBets");
    this.storageService.delete_cookie("spotGametype");

  }
  getTotalAmount() {
    const amount = 0;
    // this.betsArray.forEach(bet => {
    //   amount += bet.value
    // })
    return this.betAmount;
  }
  getTotalCombinationsValue() {
    let combinaison = 0;
    if (this.betsArray && this.betsArray.length > 0) {
      // console.log(this.activeBets);

      this.betsArray.forEach((bet) => {
        if (this.activeGameObject.icon == bet.game) {
          combinaison += bet.combinations;
        }
      });
    }
    this.activeCombinations = combinaison;
  }
  getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }
  getAmount(data: TurfBetObject): any {

    let partants = this.getNonPartant(this.activeRaceInSelectedMeeting) ? data.race.partants - this.getNonPartant(this.activeRaceInSelectedMeeting).split('-').length : data.race.partants
    // console.log( this.activeGameObject)
    this.combinationsValue = this.combinaisonCount(
      data.gameType,
      this.activeGameObject.touteOdre == '0' ? false : true,
      this.toutOdre,
      ['CT', 'CP'].includes(data.gameType) ? 0 : data.chavalBase.length,
      data.chavalBase.slice(this.activeGameObject.numbreCheveauxBase).length +
      data.chevalAssocie.length,
      partants,
      data.chavalBase
        .slice(0, this.activeGameObject.numbreCheveauxBase)
        .filter((horseNumber) => {
          return horseNumber !== 'X';
        }).length,
      this.activeGameObject.numbreCheveauxBase
    );
    this.amountTotal = this.combinationsValue * data.miseDeBase * data.coef;
    data.value = this.amountTotal;
    data.combinations = this.combinationsValue;
    this.amountTotal = this.amountTotal;
    return this.amountTotal + '';
  }
  arrangement(k, n): any {
    let r = 1;
    for (let i = 0; i < k; i++) {
      r *= n - i;
    }
    return r;
  }
  combinaison(k, n): any {
    let r = 1;
    for (let i = 0; i < k; i++) {
      // if (n != i)
      r = (r * (n - i)) / (i + 1);
    }
    // console.log(r);
    return r;
  }
  combinaisonCount(formule, ordre, toutOrdre, k, p, n, b, s): any {
    // console.log(formule, ordre, toutOrdre, k, p, n, b, s);
    if (!ordre) {
      // console.log("odre false");
      if (formule == 'CE') {
        return this.combinaison(s, k);
      }
      if (formule == 'CP') {
        return this.combinaison(s - b, p);
      }
      if (formule == 'CT') {
        return this.combinaison(s - b, n - b);
      }

    } else {
      if (!toutOrdre) {
        // console.log("odre true ttodre false");
        if (formule == 'CE') {
          return this.combinaison(s, k);
        }
        if (formule == 'CP') {
          return this.arrangement(s - b, p);
        }
        if (formule == 'CT') {
          return this.arrangement(s - b, n - b);
        }
      } else {
        // console.log("odre true ttodre true");
        if (formule == 'CE') {
          return this.arrangement(s, k);
        }
        if (formule == 'CP') {
          return this.arrangement(b, s) * this.arrangement(s - b, p);
        }
        if (formule == 'CT') {
          return this.arrangement(b, s) * this.arrangement(s - b, n - b);
        }
        if (formule == 'SI') {
          return this.arrangement(s, s);
        }
      }
    }
    return 1;
  }
  getNonPartant(race) {
    const nonPartants = [];
    if (race.partants) {
      race.partants.forEach((partant) => {
        if (partant.status !== 'Partant') {
          nonPartants.push(partant.numero);
        }
      });
      return nonPartants.join('-');
    } else {
      return '';
    }
  }

  SaveBet(): Promise<any> {

    const myHorsesArray = [];

    for (const horse of this.activeBets[0].chavalBase) {
      myHorsesArray.push(horse);
    }
    if(this.betObject.gameType == 'CP' && this.betObject.chevalAssocie.length == 1){
      this.betLoader = false;
      return Promise.reject("ml_compl_horses_not_valid")
    }
    if (this.activeBets[0].chevalAssocie) {
      for (const horse of this.activeBets[0].chevalAssocie) {
        myHorsesArray.push(horse);
      }
    }
    if (
      !this.userService.userData ||
      (this.userService.userData && !this.userService.userData.lg_AGENT_ID && !this.userService.userData.customer_ID && !this.configService.partnerOperation.enabled)
    ) {
      this.requireConfirmation = true;

      this.betLoader = false;
      return Promise.reject("ml_login_to_bet")
    }


    let flexi = this.activeGameObject.flexi == '1.0' ? 1 : 0;
    const multi = ['MULTIC3', 'PM', 'MM', 'PMM'].includes(this.activeGameObject.icon) ? '1' : '0'

    const odre =
      this.toutOdre
        ? 1
        : 0;
    const spotGametype = this.spotGametype ? '1' : '0';
    // odre = odre ? 1 : 0;
    flexi = 0;
    this.activeGameObject.compl = this.betObject.compl
      ? this.activeGameObject.compl
      : 0;
    let format = "";
    const touteOdre = !this.selectedHorses ? this.activeGameObject.touteOdre : odre;
    const betOptions = this.skeletonService.theme.betOptions;
    switch (betOptions.version) {
      case '4.3':
          format = `${!this.selectedHorses ? this.activeGameObject.icon : this.activeGameObject.icon.split('_')[0]}-${touteOdre}-${this.activeGameObject.compl}-${this.betObject.coef}` +`-${flexi}-${spotGametype}-${multi}-${myHorsesArray.join("-")}`
        break;
      case '4.0':
        format = `${!this.selectedHorses ? this.activeGameObject.icon : this.activeGameObject.icon.split('_')[0]}-${touteOdre}-${this.activeGameObject.compl}-${this.betObject.coef}` +`-${flexi}-${spotGametype}-${myHorsesArray.join("-")}`
        break;

      default:
        break;
    }


    let number = this.activeRaceInSelectedMeeting.numero;
    format = format.replace(/X/g, '*');
    let ref = new Date().getTime().toString();

    /*
       mtv: this.activeGameObject.numbreCheveauxBase ? this.activeGameObject.numbreCheveauxBase : undefined, */

    let info = {
      meetingName: this.betObject.reunion.name,
      meetingNumber: this.activeRaceInSelectedMeeting.reunion_num,
      raceName: this.betObject.race.name,
      raceNumber: number,
      gameName: this.translate.instant(this.gameTypeToName(this.betObject.game)),
    }
    let partnerInfo = this.configService.partnerOperation;
    if(partnerInfo.enabled == true){
      let partnerSaveBetParam = {
        operatorName: partnerInfo.operatorName,
        sessionId: this.userService.userData.sessionId,
        userName: this.userService.userData.login,
        number: this.betObject.race.number,
        info,
        pick: myHorsesArray.join("-"),
        format,
        ref,
        channel: 6,
        intCoef: this.betObject.coef,
        product: this.configService.partnerConfigs.productName,
        amount: this.betAmount,
        option: this.betObject.gameType,
        clientExternalKey: this.userService.userData.clientExternalKey,
      }
      return this.httpHandler.PostBearerToken(this.configService.PROXIES.partner_gateway, EndPoints.iframe_place_bet, partnerSaveBetParam, this.userService.userData.authToken)
    }else {
      this.savebetParam = {
        channel: 3,
        userid: this.userService.userData.customer_ID,
        pwd: this.configService.useGateway ? this.userService.userData.session : `${this.userService.userData.pin}@NO_CRYPT`,
        ref,
        internal_ref: ref,
        str_From: this.userService.userData.phone_number.toString().replace(/ /g, ''),
        format,
        mtv: this.activeGameObject.numbreCheveauxBase ? this.activeGameObject.numbreCheveauxBase : undefined,
        number,
        sid: this.userService.userData.session,
        uid: this.userService.userData.customer_ID
      };
      return this.httpHandler.HttpParamsPost(
        this.configService.PROXIES.save_bet + EndPoints.saveBet,
        this.savebetParam
      );
    }

  }
}
